import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import {
  tenantWizardFormSchema,
  tenantWizardFormDefaultValues,
  ITenantWizardFormModel,
} from "../models/tenantWizardFormModel";
import { useFormValidationMessages } from "../../../../../common/infrastructure/hooks/useFormHelper";

export const useTenantWizardForm = (tenant?: ITenantWizardFormModel) => {
  const form = useForm<ITenantWizardFormModel>({
    defaultValues: tenantWizardFormDefaultValues,
    resolver: yupResolver(tenantWizardFormSchema),
  });

  useEffect(() => {
    if (tenant) form.reset(tenant);
  }, [tenant, form]);

  useFormValidationMessages<ITenantWizardFormModel>(form);
  return form;
};
